/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchMaintenanceRequestsResponse } from './search-maintenance-requests-response';


export interface SearchMaintenanceRequestsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchMaintenanceRequestsResponse> | null;
}

